import * as S from './MultiRoomHeading.styles';

export default function MultiRoomHeading({headingText}) {
  return (
    <>
      <S.RecommendSection>
        <S.BorderSpan />
        <S.RecommendTextSpan>{headingText}</S.RecommendTextSpan>
        <S.BorderSpan />
      </S.RecommendSection>
    </>
  );
}
